<script>
import StepLine from "@/components/ecologist/dataEntryNew/stepLine";

const STEP = "wizardStep";

// Этапы для линии этапов те же - тогда отдаём ей прежний массив, и она не перезапускает анимацию
const sameSteps = (a, b) =>
  a.length === b.length &&
  a.every(
    (step, i) =>
      step.name === b[i].name &&
      step.title === b[i].title &&
      step.description === b[i].description
  );

/*
  Мастер ничего не знает о содержимом этапов. Этапы - дочерние <wizard-step> в порядке следования,
  какие из них есть - решают v-if на них. Активный этап - v-model с именем этапа.
  Без кнопок «Далее» и «Назад»: вперёд переводят действия на самих этапах (сменой v-model),
  назад - нажатие на пройденный этап в линии этапов
*/
export default {
  name: "stepWizard",
  components: { StepLine },
  model: { prop: "value", event: "input" },
  props: {
    // Имя активного этапа. Если такого этапа нет (убрали v-if) - активен последний
    value: { type: String, default: null },
    canGoBack: { type: Boolean, default: true },
  },

  created() {
    // Без реактивности: этапы собираются из слота при каждой отрисовке
    this.steps = [];
  },

  methods: {
    activeIndex() {
      const index = this.steps.findIndex((step) => step.name === this.value);
      return index < 0 ? this.steps.length - 1 : index;
    },

    // Вернуться к пройденному этапу
    goTo(index) {
      if (this.canGoBack && index < this.activeIndex())
        this.$emit("input", this.steps[index].name);
    },
  },

  render(h) {
    const nodes = (this.$slots.default || []).filter(
      (vnode) =>
        vnode.componentOptions &&
        vnode.componentOptions.Ctor.options.name === STEP
    );
    const steps = nodes.map((vnode) => {
      const { name, title, description } = vnode.componentOptions.propsData;
      return { name, title, description };
    });
    if (!sameSteps(steps, this.steps)) this.steps = steps;
    const active = this.activeIndex();
    const current = nodes[active];

    return h("div", { class: "step-wizard" }, [
      h("step-line", {
        props: { steps: this.steps, active, clickable: this.canGoBack },
        on: { select: this.goTo },
      }),
      this.$scopedSlots.header ? this.$scopedSlots.header() : null,
      // Ключ по этапу: при переходе содержимое пересоздаётся, а не переиспользуется от соседнего
      h(
        "div",
        { class: "step-content", key: current ? steps[active].name : null },
        current ? [current] : []
      ),
    ]);
  },
};
</script>

<style scoped>
.step-wizard {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.step-content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
